/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'

import { useForm } from "react-hook-form"

import { get, post } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

export default function index() {
  const navigate = useNavigate()
  const [resturants, setResturants] = useState([])
  const [icon, setIcon] = useState()
  const [clickButton, setClickButton] = useState(false)

  const token = localStorage.getItem('token')

  document.title = 'ایجاد دسته بندی'

  const { register, handleSubmit } = useForm()

  useEffect(() => {
    get(`/api/admin/shops?token=${token}`)
      .then(respose => {
        setResturants(respose.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let formData = new FormData()
    formData.append('icon', icon)
    formData.append('shop', data.shop)
    formData.append('title', data.title)
    formData.append('eTitle', data.eTitle)
    formData.append('level', data.level)

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } 
    post(`/api/admin/categories?token=${token}`, formData, config).then(response => {
      notify('success', response.data.messageFa)
      setTimeout(() => {
        navigate('/categories')
      }, 2000)
    }).catch(error => {
      setClickButton(false)
      if (error) {
        notify('error', error)
      }
      notify('error', 'خطا در ارسال اطلاعات')
    })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'category'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد دسته بندی
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد دسته بندی لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات دسته بندی
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * :</label>
                <select id='resturantName' {...register("shop", { required: true })}>
                  {resturants ? resturants.map((item, index) => {
                    return <option key={index} value={item._id}>{item.name}</option>
                  }) : ''}
                </select>
                <small id='resturantNameAlert'>رستوران باید انتخاب شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantDetails'>نام دسته بندی * :</label>
                <input id='resturantDetails' {...register("title", { required: true, minLength: 3 })} type='text' placeholder='مثلا پیتزا' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='resturantDetails'>نام دسته بندی انگلیسی* :</label>
                <input className='ltr' id='resturantDetails' {...register("eTitle", { required: true, minLength: 3 })} type='text' placeholder='pizza' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantAddress'>اولویت * :</label>
                <input id='resturantAddress' {...register("level", { required: true })} type='number' />
                <small id='resturantAddressAlert'>اولویت باید انتخاب شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='resturantTell'>تصویر دسته بندی * :</label>
                <input id='resturantTell' onChange={e => {
                  const fileSelect = e.target.files[0]
                  setIcon(fileSelect)
                }} type='file' />
                <small id='resturantTellAlert'>تصویر باید انتخاب شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'ایجاد دسته بندی'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
